export const filterSingleByDuration = (
  searchResults,
  maxDurationParam,
  minInitial
) => {
  let tipyBusqueda = searchResults[0].legs.length;

  let newCluster = searchResults.map(clusterObj => {
    let newLegs = clusterObj.legs.map(singleLeg => {
      let filteredFlights;

      if (maxDurationParam === minInitial) {
        filteredFlights = singleLeg.options.filter(
          flight => flight.flight_time <= maxDurationParam
        );
      } else {
        filteredFlights = singleLeg.options.filter(
          flight => flight.flight_time <= maxDurationParam
        );
      }

      if (filteredFlights.length > 0) {
        return { ...singleLeg, options: filteredFlights };
      }

      return null;
    });

    let validLegs = newLegs.filter(leg => leg !== null);

    if (validLegs.length == tipyBusqueda) {
      return { ...clusterObj, legs: validLegs };
    }

    return null;
  });

  return [...newCluster.filter(clusterObj => clusterObj !== null)];
};
